import { TOKENS } from '../tokens';
import { formatKai } from '../helper';

type Props = {
  amount: bigint | undefined;
  round?: boolean;
};

export default function KaiTokenAmount({ amount, round }: Props) {
  return (
    <div className="flex flex-row items-center gap-2">
      <img src={TOKENS.KAI.image} alt="KAI token logo" className="h-6 w-6" />
      <span className="font-medium">{formatKai(amount, round)}</span>
    </div>
  );
}
